import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeReference } from '@apollo/client';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import * as DE from '@nll/datum/lib/DatumEither';
import * as E from 'fp-ts/Either';
import { constant, pipe } from 'fp-ts/function';
import { useCallback, useContext } from 'react';
import { useLike, useUnlike } from './mutations';
export var unableToLike = function unableToLike(message) {
  return {
    severity: 'error',
    message: message || 'Sorry, we are unable to save your like',
    duration: 'medium'
  };
};
export var unableToUnlike = function unableToUnlike(message) {
  return {
    severity: 'error',
    message: message || 'Sorry, we are unable to remove your like',
    duration: 'medium'
  };
};

var isLoading = function isLoading(status) {
  return DE.isPending(status) || DE.isRefresh(status);
};

export var useLikeUnlike = function useLikeUnlike(_ref) {
  var likeTarget = _ref.likeTarget,
      typename = _ref.typename,
      userLike = _ref.userLike;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useLike = useLike({
    onCompleted: E.match(function () {
      return showAlert(unableToLike());
    }, function (_ref2) {
      var like = _ref2.like;
      return like.__typename === 'LikeErrors' && showAlert(unableToLike(like.errors[0].message));
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(console.error, function (_ref3) {
        var like = _ref3.like;

        if (like.__typename === 'LikeResult') {
          cache.modify({
            id: cache.identify(makeReference("".concat(typename, ":").concat(likeTarget.targetID))),
            fields: {
              likes: function likes(_likes) {
                var _likes$totalCount;

                return _objectSpread(_objectSpread({}, _likes !== null && _likes !== void 0 ? _likes : {}), {}, {
                  totalCount: ((_likes$totalCount = _likes === null || _likes === void 0 ? void 0 : _likes.totalCount) !== null && _likes$totalCount !== void 0 ? _likes$totalCount : 0) + 1
                });
              },
              currentUserLike: constant({
                id: like.result.id
              })
            }
          });
        }
      }));
    }
  }),
      _useLike2 = _slicedToArray(_useLike, 2),
      like = _useLike2[0],
      likeStatus = _useLike2[1];

  var _useUnlike = useUnlike({
    onCompleted: E.match(function () {
      return showAlert(unableToUnlike());
    }, function (_ref4) {
      var unlike = _ref4.unlike;
      return unlike.__typename === 'UnlikeErrors' && showAlert(unableToUnlike(unlike.errors[0].message));
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(console.error, function (_ref5) {
        var unlike = _ref5.unlike;

        if (unlike.__typename === 'UnlikeResult') {
          userLike && cache.evict({
            id: "Like:".concat(userLike.id)
          });
          cache.modify({
            id: cache.identify(makeReference("".concat(typename, ":").concat(likeTarget.targetID))),
            fields: {
              likes: function likes(_likes2) {
                var _likes2$totalCount;

                return _objectSpread(_objectSpread({}, _likes2 !== null && _likes2 !== void 0 ? _likes2 : {}), {}, {
                  totalCount: ((_likes2$totalCount = _likes2 === null || _likes2 === void 0 ? void 0 : _likes2.totalCount) !== null && _likes2$totalCount !== void 0 ? _likes2$totalCount : 1) - 1
                });
              },
              currentUserLike: constant(null)
            }
          });
          cache.gc();
        }
      }));
    }
  }),
      _useUnlike2 = _slicedToArray(_useUnlike, 2),
      unlike = _useUnlike2[0],
      unlikeStatus = _useUnlike2[1];

  var toggleLike = useCallback(function () {
    userLike ? void unlike({
      variables: {
        input: {
          id: userLike.id
        }
      }
    }) : void like({
      variables: {
        input: likeTarget
      }
    });
  }, [userLike, unlike, like, likeTarget]);
  return {
    toggleLike: toggleLike,
    isLoading: isLoading(likeStatus) || isLoading(unlikeStatus)
  };
};